export default {
      id: "reviews-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#reviews",
      toString: function () {
        return this.url;
      }
    }